import './App.css';
import TurnoForm from './turnoForm';
import Test from "./test"
import AppbarMVL from "./AppbarMVL"
import Lobby from './Lobby';
import RutasAnimadas from './RutasAnimadas';
import { useState } from 'react';
import { BrowserRouter,  } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const getBasename = path => path.substr(0, path.lastIndexOf('/'));


function App() {

  const [isIframe, setIsIframe] = useState(window.location !== window.parent.location);
    
    // console.log(process.env.PUBLIC_URL);



  return (    
    <div>
      <Helmet>
        <title>Sistema de turnos | Municipio Vicente López</title>
        {/* <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests"></meta> */}
      </Helmet>

      {!isIframe && <div className='app-bar'>
        <AppbarMVL/>
      </div>}

      <div className="App">
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <RutasAnimadas/>
        </BrowserRouter>

        {/* <div className='turnera'>
          <Test/>
        </div> */}
      </div>
        
    </div>
  );
}

export default App;
